// Nome da tecla de atalho no Novo Pedido do Delivery (cores do tema do painel).
export default function Tecla({ children, className = "" }) {
  return (
    <kbd className={`inline-flex items-center px-1.5 py-0.5 rounded-md border border-border bg-muted text-[11px] font-semibold leading-none text-muted-foreground ${className}`}>
      {children}
    </kbd>
  );
}
